/* eslint-disable react-hooks/exhaustive-deps */
import { debounce } from 'lodash';
import { useEffect, useState } from 'react';

import { useFilterStore } from 'src/stores/filters/filters.store';
import { Option } from 'src/types/common/option';

export const useFilter = (getData: () => void) => {
  const { filters, setFilters, removeFilter } = useFilterStore();
  const [selectedCategory, setSelectedCategory] = useState<Option | undefined>(undefined);
  const [selectedStatus, setSelectedStatus] = useState<Option | undefined>(undefined);

  const categoriesOptions = [
    { label: 'Eventos', value: 'events' },
    { label: 'Restaurantes', value: 'restaurant' },
    { label: 'Lojas', value: 'stores' },
  ];

  const statusOptions = [
    { label: 'Ativo', value: 'active' },
    { label: 'Inativo', value: 'inactive' },
  ];

  const onSearch = debounce((value: string) => {
    if (value.length > 0 && value !== '') {
      setFilters({ ...(value && { name: value }) });
    } else {
      removeFilter('name');
    }
  }, 1000);

  const handleSelectCategory = (option: Option | undefined) => {
    setSelectedCategory(option);
    if (!option) {
      removeFilter('type');
    } else {
      setFilters({ ...(option && { type: option.value }) });
    }
  };

  const handleSelectStatus = (option: Option | undefined) => {
    setSelectedStatus(option);
    if (!option) {
      removeFilter('status');
    } else {
      setFilters({ ...(option && { status: option.value }) });
    }
  };

  const handleRemoveCategoryFilter = (id: string) => {
    setSelectedCategory(undefined);
    removeFilter('type');
  };

  const handleRemoveStatusFilter = (id: string) => {
    setSelectedStatus(undefined);
    removeFilter('status');
  };

  const handleRemoveAllFilters = () => {
    setSelectedCategory(undefined);
    setSelectedStatus(undefined);
    removeFilter('type');
    removeFilter('status');
  };

  useEffect(() => {
    getData();
  }, [filters]);

  return {
    categoriesOptions,
    statusOptions,
    selectedCategory,
    selectedStatus,
    handleRemoveCategoryFilter,
    handleRemoveStatusFilter,
    handleRemoveAllFilters,
    handleSelectCategory,
    handleSelectStatus,
    onSearch,
  };
};
